import React from "react";
import PropTypes from "prop-types";

import { OrderObject } from "../Queries/OrderQuery";

class CompleteOrderBtn extends React.Component {
  render() {
    return (
      <React.Fragment>
        <button className="button red" style={{ marginLeft: 8 }} onClick={this.confirm}>
          Mark Order Complete
        </button>
      </React.Fragment>
    );
  }

  confirm = () => {
    if (window.confirm("Are you sure you want to mark this order as complete?")) {
      this.completeOrder();
    }
  };

  completeOrder = () => {
    const { update, order } = this.props;
    update({
      variables: {
        id: order.id
      }
    });
  };
}

CompleteOrderBtn.propTypes = {
  order: OrderObject.isRequired,
  update: PropTypes.func.isRequired
};

export default CompleteOrderBtn; 